import React from "react";
import { Row, Col, Button, InputGroup, Form } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes } from "src/common";
import { Icon } from "src/components";

type AllProps = {
    users_list_length: number;
    filtered_length: number;
    handleAction: ActionHandlerFunction;
    filter_param?: string;
};

// Description: This component is used to render the toolbar of the list of users in the data export get started page
function ToolbarComponent(props: AllProps) {
    const { users_list_length, filtered_length, filter_param, handleAction } = props;

    return <Row className="toolbar admin">
        <Col xs="auto" className="ps-2 ms-1 col-sm-4">
            <InputGroup size="sm">
                <InputGroup.Text>
                    <Icon className="ficon-filter" />
                </InputGroup.Text>
                <Form.Control
                    id="filter_tb"
                    disabled={users_list_length === 0}
                    value={filter_param}
                    onChange={(e) =>
                        handleAction({
                            actionType: AdminUIActionTypes.SearchParam,
                            params: e.target.value,
                        })
                    }
                    type="text"
                    placeholder="Filter..."
                    aria-label="Filter"
                />
                {
                    !!filter_param && filter_param.length > 0 &&
                    <Button
                        variant="icon"
                        size="sm"
                        className="input-group-btn"
                        onClick={() => {
                            handleAction({ actionType: AdminUIActionTypes.SearchParam });
                        }} >
                        <Icon className="ficon-x-circle" />
                    </Button>
                }
            </InputGroup>
        </Col>
        <Col xs="auto" className="order-sm-3 order-4 me-2 ms-auto pagination_info">
            {filtered_length > 0 && `${filtered_length} User${filtered_length > 1 ? "s" : ""}`}
        </Col>
    </Row >;
}

export default React.memo(ToolbarComponent);